module.exports = "https://static.energy5.com/_next/static/images/webApp-fbf03f5d81ed99281698de8556842258.png";